// Import React Library
import React from 'react';

// React icons
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import RingVolumeIcon from '@mui/icons-material/RingVolume';
import InstagramIcon from '@mui/icons-material/Instagram';

// Import Components
import Divider from './Divider';

// Footer Component
const Footer = () => {

    // Current Date
    const currentDate = new Date();

    return (
        <div className='footer bg-gradient-to-r from-gray-800 to-gray-900 text-white'>
            <div className='footer-row'>
                <div className='footer-col'>
                    <AccessTimeIcon fontSize='large' className='footer-icon'/>            
                    <p className='font-bold uppercase'>Ruta 101 y Los aromos</p>
                    <br />
                    <p>Lunes a Viernes</p>
                    <p>09:00 a 17:00hs</p>
                    <br />
                    <p>Sabados</p>
                    <p>09:00 a 13:00hs</p>
                </div>

                <div className='footer-col'>
                    <AccessTimeIcon fontSize='large' className='footer-icon'/>            
                    <p className='font-bold uppercase'>Local 8 - KM 27.100</p>
                    <br />
                    <p>Lunes a Viernes</p>
                    <p>09:00 a 17:00hs</p>
                    <br />
                    <p>-</p>
                    <p>-</p>
                </div>

                <div className='footer-col'>
                    <MeetingRoomIcon fontSize='large' className='footer-icon'/>            
                    <p className='font-bold uppercase'>Deposito camino ventura</p>
                    <br />
                    <p>-</p>
                    <p>-</p>
                    <br />
                    <p>-</p>
                    <p>-</p>
                </div>

                {/* Teléfonos convertidos en enlaces tel: */}
                <div className='footer-col'>
                    <RingVolumeIcon fontSize='large' className='footer-icon'/>            
                    <p className='font-bold uppercase'>Teléfono</p>
                    <br />
                    <a 
                        href='tel:+59899384353' 
                        className='text-white no-underline hover:text-white focus:text-white'
                        aria-label='Llamar al 099 384 353'
                        title='Llamar al 099 384 353'
                    >
                        <p>099 384 353</p>
                    </a>
                    <br />
                    <a 
                        href='tel:+59822891112' 
                        className='text-white no-underline hover:text-white focus:text-white'
                        aria-label='Llamar al 2289 11 12'
                        title='Llamar al 2289 11 12'
                    >
                        <p>2289 11 12</p>
                    </a>
                    <br />
                    <a 
                        href='tel:+59826966155' 
                        className='text-white no-underline hover:text-white focus:text-white'
                        aria-label='Llamar al 2696 61 55'
                        title='Llamar al 2696 61 55'
                    >
                        <p>2696 61 55</p>
                    </a>
                    <p>-</p>
                </div>

                <div className='footer-col'>
                    <a 
                        href='https://www.instagram.com/prehouseuruguay' 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className='text-white no-underline hover:text-white focus:text-white'
                    >
                        <InstagramIcon fontSize='large' className='footer-icon'/>            
                        <p className='font-bold uppercase'>Instagram</p>
                        <br />
                        <p>@prehouseuruguay</p>
                        <br />
                        <p>@prehouse.arquitectura</p>
                    </a>
                    <p>-</p>
                    <p>-</p>
                </div>
            </div>

            <Divider />

            <div className='footer-row'>
                © {currentDate.getFullYear()} - PreHouse Uruguay . Todos los derechos reservados.
            </div>
        </div>
    );
};

// Export Footer Component
export default Footer;
